<template>
    <div class="container">
        <div class="faqs-card">
            <h5 class="faqs-card-title">
                {{trans.get("faqs.shipping.title1")}}
            </h5>
            <p class="faqs-card-text">
                {{trans.get("faqs.shipping.text1")}}
            </p>
            <div class="faqs-card-line"></div>
        </div>
        <div class="faqs-card">
            <h5 class="faqs-card-title">
                {{trans.get("faqs.shipping.title2")}}
            </h5>
            <p class="faqs-card-text">
                {{trans.get("faqs.shipping.text2")}}
            </p>
            <div class="faqs-card-line"></div>
        </div>
        <div class="faqs-card">
            <h5 class="faqs-card-title">
                {{trans.get("faqs.shipping.title3")}}
            </h5>
            <p class="faqs-card-text">
                {{trans.get("faqs.shipping.text3")}}
            </p>
            <div class="faqs-card-line"></div>
        </div>

        <div class="faqs-card">
            <h5 class="faqs-card-title">
                {{trans.get("faqs.shipping.title4")}}
            </h5>
            <div class="faqs-card-text">
                <p>
                    {{trans.get("faqs.shipping.text4")}}
                </p>
                <ul class="mt-6">
                    <li>{{trans.get("faqs.shipping.list4_01")}}</li>
                    <li>{{trans.get("faqs.shipping.list4_02")}}</li>
                </ul>
            </div>

            <div class="faqs-card-line"></div>
        </div>
        <div class="faqs-card">
            <h5 class="faqs-card-title">
                {{trans.get("faqs.shipping.title5")}}
            </h5>
            <p class="faqs-card-text">
                {{trans.get("faqs.shipping.text5")}}
            </p>
            <div class="faqs-card-line"></div>
        </div>
        <div class="faqs-card">
            <h5 class="faqs-card-title">
               {{trans.get("faqs.shipping.title6")}}
            </h5>
            <p class="faqs-card-text">
                {{trans.get("faqs.shipping.text6")}}
            </p>
            <div class="faqs-card-line"></div>
        </div>
        <div class="faqs-card">
            <h5 class="faqs-card-title">
                {{trans.get("faqs.shipping.title7")}}
            </h5>
            <p class="faqs-card-text">
                {{trans.get("faqs.shipping.text7")}}
            </p>
            <div class="faqs-card-line"></div>
        </div>
        <div class="faqs-card">
            <h5 class="faqs-card-title">
                {{trans.get("faqs.shipping.title8")}}
            </h5>
            <p class="faqs-card-text">
                {{trans.get("faqs.shipping.text8")}}
            </p>
            <div class="faqs-card-line"></div>
        </div>
        <div class="faqs-card">
            <h5 class="faqs-card-title">
                {{trans.get("faqs.shipping.title9")}}
            </h5>
            <p class="faqs-card-text">
                {{trans.get("faqs.shipping.text9")}}
            </p>

        </div>
    </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
.faqs-card {
    width: 100%;
    display: flex;
    flex-direction: column;
    .faqs-card-title {
        margin-top: 3rem;
        margin-bottom: 1rem;
    }
    .faqs-card-text {
        margin-bottom: 3rem;
    }
    .faqs-card-line {
        border: solid 1px #a5ab90;
    }
}
</style>
